import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

import { discussionVoteCreate } from "~/store/graphql/mutations/discussionVoteCreate.graphql";

const createDiscussionVote = async function (
  { commit, state },
  { discussionReplyId, parentDiscussionReplyId }
) {
  commit("START_LOADING");

  await runGraphQLQuery(
    discussionVoteCreate,
    {
      entityId: discussionReplyId,
      entityType: "DISCUSSION_REPLY",
    },
    this.$axios
  );

  commit("CREATE_DISCUSSION_REPLY_VOTE", {
    discussionReplyId,
    parentDiscussionReplyId,
  });

  commit("END_LOADING");

  return Promise.resolve();
};

export default createDiscussionVote;
